import { Popover } from "react-tiny-popover";
import React, { useState, useEffect } from "react";
import "./ProfileDropdown.scss";
import { CgProfile } from "react-icons/cg";
import { AiOutlineCaretDown } from "react-icons/ai";
import { getAltAddress, logout } from "../../utils/services/auth";
import { copyToClipboard } from "../../utils/services/other";
import { MdOutlineContentCopy } from "react-icons/md";
import { useSelector } from "react-redux";
import History from "../../utils/services/GlobalNavigation/navigationHistory";
import { web3auth } from "../../utils/services/web3auth";

function ProfileDropdown() {
  const userId = getAltAddress();
  const [isPopoverOpen, setIsPopoverOpen] = useState<boolean>(false);
  const [email, setEmail] = useState<string>("");
  const authStore = useSelector((store: any) => store?.auth);

  useEffect(() => {
    let componentMounted = true;
    if (componentMounted) {
      if (authStore?.loginType === "openlogin" && web3auth?.connected) {
        (async () => {
          const userData = await web3auth?.getUserInfo();
          setEmail(userData?.email || "");
        })();
      }
    }
    return () => {
      componentMounted = false;
    };
  }, []);

  async function systemLogout() {
    //
    await logout();
  }

  return (
    <Popover
      isOpen={isPopoverOpen}
      containerClassName="ProfilePopover"
      positions={["bottom"]}
      onClickOutside={() => setIsPopoverOpen(false)}
      content={
        <div className="ProfileDropdown">
          <div className="label">Public Address</div>
          <div className="userName">
            {userId
              ? userId.substring(0, 4) +
                "...." +
                userId.substring(userId.length - 4)
              : ""}

            <div
              className="icon"
              onClick={() => {
                const address = getAltAddress();
                address && copyToClipboard(address);
              }}
            >
              <MdOutlineContentCopy />
            </div>
          </div>
          {authStore?.loginType === "openlogin" && (
            <>
              <div className="label">Email Address</div>
              <div className="userName">
                {email}

                <div
                  className="icon"
                  onClick={() => {
                    copyToClipboard(email);
                  }}
                >
                  <MdOutlineContentCopy />
                </div>
              </div>
            </>
          )}

          <button
            className="outlineBtn"
            style={{ width: "100%" }}
            onClick={systemLogout}
          >
            Logout
          </button>
        </div>
      }
    >
      <div
        className="ProfileDropdownBtn"
        onClick={() => setIsPopoverOpen(!isPopoverOpen)}
      >
        <CgProfile
          onClick={() => {
            History.push("/dashboard/profile");
          }}
        />
        &nbsp;
        <span>|</span>&nbsp;
        <span className="userName">
          {userId
            ? userId.substring(0, 4) +
              "...." +
              userId.substring(userId.length - 4)
            : ""}
        </span>
        <span className="dropdown">
          <AiOutlineCaretDown />
        </span>
      </div>
    </Popover>
  );
}

export default ProfileDropdown;
